import { hCustomValidate } from '@/utils/helpers';

// @vue/component
export default {
  name: 'MultipleAdd',

  props: {
    title: {
      type: String,
      default: 'Added elements',
    },
    addedItems: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: 'Name',
    },
    warningOnDuplicate: {
      type: String,
      default: 'Item has already been added',
    },
    assertions: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Add new item',
    },
    clearTooltipText: {
      type: String,
      default: 'Wyczyść listę',
    },
  },

  data() {
    return {
      newItem: '',
      isTooltipVissible: false,
      errorMessage: null,
    };
  },

  computed: {
    hasAddedItems() {
      return this.addedItems.length > 0;
    },
    addedItemsPlaceholder() {
      return (this.addedItems.length >= 2
        ? `${this.addedItems.slice(0, 2).join(', ')}...`
        : this.addedItems.join(', ')
      );
    },
  },

  methods: {
    __emitAddItemEvent() {
      if (!this.addedItems.includes(this.newItem)) {
        this.$emit('add', { newItem: this.newItem, name: this.name });
        this.newItem = '';
        this.isTooltipVissible = false;
      } else {
        this.isTooltipVissible = true;
      }
    },
    handleAddItem() {
      const validation = hCustomValidate(this.newItem, this.assertions);
      if (validation.isPass) {
        this.__emitAddItemEvent();
        this.errorMessage = null;
      } else {
        this.errorMessage = validation.errors[0].message;
        this.isTooltipVissible = true;
      }
    },
    removeItem(item) {
      this.$emit('remove', { item, name: this.name });
    },
    removeAllElements() {
      if (this.hasAddedItems) this.$emit('clear', { name: this.name });
    },
  },
};
